export const toPascalCase = (text: string): string => {
  return text.replace(/(^\w|-\w)/g, clearAndUpper);
};

const clearAndUpper = (text: string): string => {
  return text.replace(/-/, "").toUpperCase();
};

export const capitalize = <T extends string>(s: T): Capitalize<T> => {
  if (s === "") return s as Capitalize<T>;
  return (s?.[0]?.toUpperCase() + s?.slice(1)) as Capitalize<typeof s>;
};

export const slugifyText = (text: string): string =>
  text
    .toLowerCase()
    .trim()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/  +/g, " ")
    .replace(/\s/g, "-");

export const formatLinkFromContribution = (
  entry: string,
  universalLinks: string[],
  deepLinkPrefix: string
): string => {
  for (const link of universalLinks) {
    if (entry.includes(link)) return entry.replace(link, deepLinkPrefix);
  }
  return entry;
};
